module.exports = __webpack_public_path__ + "media/images/back-hover-269fb3521970d453c508335766cc3f77.svg";